import Account from 'src/entities/accounts/Account';
import { EntityDescriptions } from 'src/entities/description';
import EntityDescription from 'src/entities/description/EntityDescription';
import { AutoFormFields } from '../BaseEntity';

export type CustomerFormFields = AutoFormFields<Customer>;

export default class Customer extends Account {
	constructor(json: any) {
		super(json);
	}

	getEntityDescription(): EntityDescription {
		return EntityDescriptions.CUSTOMER;
	}

	static formFields(entity?: Customer): CustomerFormFields {
		return {
			...Account.formFields(entity),
		};
	}
}
